import { render, staticRenderFns } from "./MessageTextForm.vue?vue&type=template&id=f722d306&scoped=true&"
import script from "./MessageTextForm.vue?vue&type=script&lang=ts&"
export * from "./MessageTextForm.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTextForm.vue?vue&type=style&index=0&id=f722d306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f722d306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VProgressCircular,VRow})
